/*
  SALTE drop — delat skript för limited edition-sektionerna.

  [data-salte-countdown]  räknar ned mot data-end (Unix-sekunder, satt av Liquid
                          i butikens tidszon). Fälten fylls redan av Liquid vid
                          renderingen, så sidan visar rimliga siffror även utan
                          skript.
  [data-salte-buy]        länkar utan egen adress skrollar till temats köpruta
                          (main-product) på samma sida.
*/
(function () {
  if (window.salteDrop) return;
  window.salteDrop = true;

  function pad(n) {
    return n < 10 ? '0' + n : String(n);
  }

  function tick() {
    var now = Date.now() / 1000;
    document.querySelectorAll('[data-salte-countdown]').forEach(function (el) {
      var end = parseInt(el.getAttribute('data-end'), 10);
      if (!end) return;
      var left = Math.max(0, Math.floor(end - now));
      var parts = {
        d: Math.floor(left / 86400),
        h: pad(Math.floor(left / 3600) % 24),
        m: pad(Math.floor(left / 60) % 60),
        s: pad(left % 60),
      };
      Object.keys(parts).forEach(function (k) {
        el.querySelectorAll('[data-cd="' + k + '"]').forEach(function (node) {
          node.textContent = parts[k];
        });
      });
      el.classList.toggle('is-ended', left === 0);
    });
  }

  function buyTarget() {
    return document.querySelector('[id^="MainProduct-"]') || document.querySelector('product-info');
  }

  document.addEventListener('click', function (event) {
    var link = event.target.closest('[data-salte-buy]');
    if (!link) return;
    var target = buyTarget();
    if (!target) return;
    event.preventDefault();
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });

  tick();
  setInterval(tick, 1000);
})();
